import { useMutation } from '@tanstack/react-query';
import axiosClient from 'api/config/axios';

type Params = {
  tradeId: string;
  orderId: string;
  isTrader: boolean;
};

async function sendNotify(params: Params) {
  if (params.isTrader) {
    return axiosClient.mutate.post('/api/v1/order/chat/push', { order_id: params.orderId });
  } else {
    return axiosClient.mutate.post('/api/v1/trade/chat/push', { trade_id: params.tradeId });
  }
}

const mutationKey = ['chat', 'notify'] as const;

export function useChatSendNotifyMutation() {
  return useMutation({
    mutationKey,
    mutationFn: sendNotify,
  });
}
